/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../notes/notes.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareEmployeeFactory {
        loadEmployee(locationId: number, id: number) : ng.IPromise<{}>;
        loadEmployeeByConfirmationToken(confirmation_token: string) : ng.IPromise<{}>;
        getInstance() : IDealerwareEmployee;
    }

    export interface IDealerwareEmployee {
        employeeId: number;
        accountSettings: any;
        fullName: string;

        clear() : void;
        clearAccountSettings() : void;
        loadAccountSettings(locationId?: number, employeeId?: number) : ng.IPromise<{}>;
        loadAccountSettingsByConfirmationToken(confirmationToken: string) : ng.IPromise<{}>;
        searchDisplay() : string;
    }
}